(ns dre.app.invert-color)

;; from https://stackoverflow.com/a/35970186/6264

(defn pad-zero [s]
  (let [len 2
        zeroes (apply str (repeat len "0"))]
    (.slice (str zeroes s) len)))

(defn parse-int [x base]
  #?(:clj (Integer/parseInt x base)
     :cljs (js/parseInt x base)))

(defn invert-color [hex bw]
  (let [hex (subs hex 1)
        r (parse-int (subs hex 0 2) 16)
        g (parse-int (subs hex 2 4) 16)
        b (parse-int (subs hex 4 6) 16)]
    (if bw
      (if (> (+ (* r 0.299)
                (* g 0.587)
                (* b 0.113))
             186)
        "#000000"
        "#ffffff")
      (let [r (str (- 255 r) 16)
            g (str (- 255 g) 16)
            b (str (- 255 b) 16)]
        (str "#" (pad-zero r) (pad-zero g) (pad-zero b))))))

;;;; End color inverting
